import { useEffect, useState } from 'react';
import { Bug, X } from 'lucide-react';
import { useAuthStore } from '../../stores/authStore';
import { BugReportModal } from './BugReportModal';

const HIDE_KEY = 'otto_bug_reporter_hidden';

export function BugReportButton() {
  const { isDevMode } = useAuthStore();
  const [hidden, setHidden] = useState<boolean>(() => {
    try {
      return sessionStorage.getItem(HIDE_KEY) === '1';
    } catch {
      return false;
    }
  });
  const [hover, setHover] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (hidden) {
      try {
        sessionStorage.setItem(HIDE_KEY, '1');
      } catch {
        /* ignore */
      }
    }
  }, [hidden]);

  if (hidden) return null;

  const positionClass = isDevMode ? 'bottom-16 right-4' : 'bottom-4 right-4';

  return (
    <>
      <div
        className={`fixed ${positionClass} z-40 flex items-center gap-1`}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
      >
        <button
          type="button"
          onClick={() => setOpen(true)}
          title="Report a bug"
          aria-label="Report a bug"
          className="bg-white/[0.06] border border-white/10 rounded-full p-2.5 text-gray-400 hover:text-cyan-400 hover:border-cyan-500/30 transition-colors"
        >
          <Bug size={16} />
        </button>
        {hover && (
          <button
            type="button"
            onClick={() => setHidden(true)}
            title="Hide for this session"
            aria-label="Hide bug reporter for this session"
            className="bg-white/[0.04] border border-white/10 rounded-full p-1 text-gray-500 hover:text-gray-200 hover:border-white/20 transition-colors"
          >
            <X size={12} />
          </button>
        )}
      </div>
      {open && <BugReportModal onClose={() => setOpen(false)} />}
    </>
  );
}
